<template>
  <div class="step-btns">
    <div class="step-content" v-show="value == 0">
      <div class="step-btn step-1" @click="bindNextStep">下一步</div>
    </div>
    <div class="step-content" v-show="value == 1">
      <div class="step-btn step-2 white-btn" @click="bindPreviousStep"
        >上一步</div
      >
      <div class="step-btn step-2 next-btn" @click="bindNextStep">下一步</div>
    </div>
    <div class="step-content" v-show="value == 2">
      <div class="step-btn white-btn step-3" @click="bindPreviousStep"
        >上一步</div
      >
      <div class="step-btn white-btn step-3" @click="bindSave">保存</div>
      <div class="step-btn publish-btn" @click="bindRelease">发布</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  methods: {
    bindNextStep() {
      this.$emit('next')
    },
    bindPreviousStep() {
      this.$emit('previous')
    },
    bindSave() {
      this.$emit('save')
    },
    bindRelease() {
      this.$emit('release')
    }
  }
}
</script>
<style lang="scss" scoped>
.step-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .step-btn {
    height: 36px;
    text-align: center;
    line-height: 36px;
    background: #6236ff;
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  .step-1 {
    width: 100%;
  }
  .step-2 {
    width: 165px;
  }
  .step-3 {
    width: 102px;
  }
  .white-btn {
    background: #ffffff;
    border: 1px solid #f1f1f1;
    color: rgba(0, 0, 0, 0.8);
    box-sizing: border-box;
  }
  .publish-btn {
    width: 121px;
  }
}
</style>
